// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Accordion from '../../../../shared/components/accordion';
import AuditPreparation from '@deere/cps-it.warranty-model-factory/lib/audit-preparation';
import {FormattedMessage} from 'react-intl';
import PrepareAuditListItem from '../../../shared/components/prepare-audit-list-item';
import {buildNumber} from '../../../../shared/services/build-number';

function handleRemoveFromAudit(itemToRemove) {

    this.actions.removeFromAudit(itemToRemove);

}

const UserSelectedClaimsAccordion = props => {

    const userSelectedClaims = props.auditPreparation.claims.filter(claim =>
        !claim.isSystemSelected
    );

    const body = userSelectedClaims.map(item =>
        <PrepareAuditListItem
            item={item}
            key={item.claimNumber}
            onRemoveFromAudit={props::handleRemoveFromAudit}
        />
    );

    const title = (
        <div className='user-selected-claims-accordion-title'>
            <FormattedMessage
                id='USER_SELECTED_CLAIMS_WITH_COUNT'
                values={{
                    count: buildNumber(userSelectedClaims.length)
                }}
            />
        </div>
    );

    return (
        <div>
            <Accordion
                accordionId='user-selected-claims-accordion'
                body={body}
                title={title}
            />
        </div>
    );

};

UserSelectedClaimsAccordion.displayName = 'UserSelectedClaimsAccordion';
UserSelectedClaimsAccordion.propTypes = {
    actions: PropTypes.object.isRequired,
    auditPreparation: PropTypes.instanceOf(AuditPreparation).isRequired
};

export default UserSelectedClaimsAccordion;



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/components/user-selected-claims-accordion/user-selected-claims-accordion.js